import { useDrag } from 'react-dnd'

const ProjectBlobNarrow = (props) => {
    
    var local = new Date(props.project.due_date);
    var offset = local.getTimezoneOffset();
    var due_date = new Date(local.getTime() + offset * 60000);

    function convertCurrencyToDouble(currency, locale = 'en-US', currencyType = 'USD') {
        // Creating a NumberFormat object with specified locale and currency
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyType,
            currencyDisplay: 'symbol'
        });
    
        // Formatting the currency to remove any non-numeric characters except for decimal point
        const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
    
        // Converting the normalized string to a double value using Number constructor
        const doubleValue = Number(normalizedCurrency);
    
        // Returning the double value
        return doubleValue;

    }



    const fee = convertCurrencyToDouble(props.project.fee)
    const paid = convertCurrencyToDouble(props.project.paid)

    // console.log(props.project)
    const name = props.project.title
    const id = props.project.id
    const project = props.project
    const [{ isDragging }, dragRef] = useDrag({
        type: 'project',
        item: { project },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    })

    const statusColorMap = {
        "Not Started":        "#DC0000",
        "Awaiting Assets":    "#FF3300",
        "In Progress":        "#ff7700",
        "Awaiting Feedback":  "#ffb200",
        "Revising":           "#ffee00",
        "Mastering":          "#B2DF00",
        "Delivering":         "#46C408",
        "Complete":           "#00a116",
    };
    const accentColor = statusColorMap[props.project.status] || "#444";

    const blobBaseClasses = "projectBlobNarrow rounded-lg px-4 py-2 hoverLeft";
    const activeBlobClasses = isDragging
        ? "opacity-40"
        : "gradientWhite";

    return (
        <div
            className={`${blobBaseClasses} ${activeBlobClasses}`}
            style={{ borderLeft: `3px solid ${accentColor}` }}
            ref={dragRef}
        >
            <div className="grid grid-cols-7 text-xs items-center">
                <span className='text-[#777] font-semibold uppercase col-span-2 pr-1 overflow-hidden text-nowrap text-ellipsis tracking-wide'>
                    {props.project.client}
                </span>
                <h4 className="text-[#e0e0e0] col-span-2 overflow-hidden text-nowrap text-ellipsis font-medium">
                    {props.project.title}
                </h4>
                {paid >= fee ?
                    <div className="w-fit text-[7px] uppercase font-bold rounded-full px-1.5 py-0.5 m-auto tracking-widest"
                         style={{ color: '#46C408', background: 'rgba(70,196,8,0.15)', border: '1px solid rgba(70,196,8,0.35)' }}>
                        Paid
                    </div>
                    :
                    <div className='col-span-1'></div>
                }
                <div className="text-[8px] font-medium text-nowrap text-[#555] col-span-2 tracking-wide">
                    &nbsp;Due {due_date.toDateString()}
                </div>
            </div>
        </div>
    )
}

export default ProjectBlobNarrow